/**
 * A minimal palette mirroring the app's brand tokens. Inlined rather than
 * imported from the RN `constants/theme` so the portal stays free of React
 * Native deps; the handful of values here are the ones the page uses. Keep in
 * step with the app if the brand shifts.
 */
export const t = {
  brand: '#FF8A6B',
  brandTint: '#FF8A6B18',
  charcoal: '#2D3748',
  textSecondary: '#6B7280',
  textMuted: '#9CA3AF',
  paper: '#FBF8F5',
  card: '#FFFFFF',
  border: '#EDE9E3',
  // status pills
  blueBg: '#E6F1FB',
  blueText: '#0C447C',
  greenBg: '#EAF3DE',
  greenText: '#3B6D11',
  amberBg: '#FAEEDA',
  amberText: '#854F0B',
} as const;

/** Marketing site — every brand element links here. */
export const WEBSITE_URL = 'https://www.axlerun.com.au';

export const FONT = "'Manrope', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif";

/** Coarse status → pill colour. Unknown statuses fall back to neutral. */
export function statusPill(status?: string | null): { bg: string; fg: string; label: string } {
  switch (status) {
    case 'EnRoute': return { bg: t.amberBg, fg: t.amberText, label: 'On the way' };
    case 'Arrived': return { bg: t.greenBg, fg: t.greenText, label: 'Arrived' };
    case 'InProgress': return { bg: t.blueBg, fg: t.blueText, label: 'In progress' };
    case 'Assigned': return { bg: t.blueBg, fg: t.blueText, label: 'Scheduled' };
    default: return { bg: '#F1EFE8', fg: '#5F5E5A', label: status ?? 'Scheduled' };
  }
}
